// extracted by mini-css-extract-plugin
export default {"tasks":"TaskList_tasks__8345T"};